import React, { useMemo } from 'react';
import './Profile.css'
import { Link as Anchor } from 'react-router-dom';
import { useData } from '../DataContext';
import { useLogo } from '../LogoContext';
import { ruta } from '../paths';
export default function Profile() {
    const { contacto } = useData();
    const { logo } = useLogo();

    const contactos = useMemo(() => {
        if (Array.isArray(contacto)) {
            return [...contacto].reverse()[0] || {};
        }
        return contacto || {};
    }, [contacto]);

    return (
        <div className='profileContain'>
            <img src={logo} alt="" />
            <h2>{contactos.nombre}</h2>

            <div className='socials'>
                <Anchor to={contactos.instagram} target="_blank"><i className='fa fa-instagram'></i></Anchor>
                <Anchor to={`tel:${contactos.telefono}`} target="_blank"><i className='fa fa-whatsapp'></i></Anchor>
                <Anchor to={contactos.facebook} target="_blank"><i className='fa fa-facebook'></i></Anchor>
            </div>

            <div className='profileText'>
                <Anchor to={ruta('/productos')} >
                    Productos
                </Anchor>
                <Anchor to={`mailto:${contactos.email}`} target="_blank">{contactos.email}</Anchor>
                <Anchor to={`https://www.google.com/maps?q=${encodeURIComponent(contactos.direccion)}`} target="_blank">{contactos.direccion}</Anchor>

            </div>
        </div>
    )
}
